
import FilterDateInput from "../shared/input/topPagesMap/FilterDateInput";
import {BiSolidLeftArrow, BiSolidRightArrow} from "react-icons/bi"
import styled from "styled-components";
import { setActiveLocationOrderForAnimation, setAnimationControlType, setAnimationFocusType, setLiveStreetView, setDetailsMarkerItem, setAnimationViewType, setLocationPointPauseFilter, setMaxSpeedValue, setMaxSpeedFilter } from "../../features/topPagesMap/topPagesMapSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { motion } from 'framer-motion';
import LineSliderInput from "../shared/input/topPagesMap/LineSpeedSliderInput";
import { RxDoubleArrowLeft, RxDoubleArrowRight  } from "react-icons/rx";
import { MdOutlinePause } from "react-icons/md";

import right from "../../images/svg/topPages/right.svg"
import left from "../../images/svg/topPages/left.svg"
import pause from "../../images/svg/topPages/pause.svg"
import run from "../../images/svg/topPages/run.svg"
import { useEffect, useState } from "react";
import LineSpeedSliderInput from "../shared/input/topPagesMap/LineSpeedSliderInput";
import LineRouteSliderInput from "../shared/input/topPagesMap/LineRouteSliderInput";
import InputCheckbox from "../shared/input/topPagesMap/InputCheckbox";
import InputNumberNew from "../shared/input/new/InputNumberNew";




const Container = styled(motion.div)`
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .animation-container{
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        gap: 15px;

      .date-filter-container{
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;

        .date-filter-item{
            display: flex;
            flex-direction: column;
            gap: 5px;
            justify-content: flex-start;

            .date-filter-item-title{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-xl);
            }
        }
      } 
        
        .animation-item{
          display: flex;
          flex-direction: column;

          h4{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
            padding: 10px 0 5px;
            border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
          }

          .filter-container{
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin: 20px 0;

            .filter-item{
              display: flex;
              align-items: center;
              gap: 10px;
            }
          }

          .view-grp{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 40px;
            padding: 15px 0;
            padding-right: 40px;

            .view-name{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-xl);
            }

            .colon{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-xl);
            }
          }

          .arr-control-container{
            display: flex;
            margin: 0 auto;
            width: 80%;
            border-radius: 5px;
            overflow: hidden;
            margin-top: 20px;

            .arr-control-item{
              flex: 1;
              background-color: var(--color-main);
              height: 45px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              &:hover{
                background-color: #f5685b;

                .arr-control-item-icon{
                }
              }

              .arr-control-item-icon{
                width: 18px
              }

            }
          }

      }

    }
    
`

const TopPagesMapLeftSideAnimationSection = ({minDate, maxDate}) => {

    const {

      topPagesMapSingleShipmentItemLocationList,
      activeLocationOrderForAnimation,
      animationControlType,
      animationControlSpeed,
      animationControlRoute,
      animationFocusType,
      filterStartDate,
      animationViewType,
      filterEndDate,
      locationPointPauseFilter,
      maxSpeedValue,
      maxSpeedFilter
    } = useSelector(state => state.topPagesMap)

    const dispatch = useDispatch()

    //! animation control
    useEffect(()=> {
      if(activeLocationOrderForAnimation === topPagesMapSingleShipmentItemLocationList.length){
        dispatch(setAnimationControlType("pause"))
      }
    },[activeLocationOrderForAnimation, topPagesMapSingleShipmentItemLocationList.length])

    const handleAnimationClick = (type) => {

      if(type === "forward"){
        dispatch(setAnimationControlType("forward"))
        dispatch(setActiveLocationOrderForAnimation(activeLocationOrderForAnimation >= 1 && activeLocationOrderForAnimation < topPagesMapSingleShipmentItemLocationList.length  ? activeLocationOrderForAnimation+1 : 1))
      }

      else if(type === "back"){
        dispatch(setAnimationControlType("back"))
        dispatch(setActiveLocationOrderForAnimation(activeLocationOrderForAnimation <= topPagesMapSingleShipmentItemLocationList.length && activeLocationOrderForAnimation > 1  ? activeLocationOrderForAnimation-1 : 1))
      }

      else if(type === "animate"){
        dispatch(setAnimationControlType("animate"))
      }

      else{
        // dispatch(setActiveLocationOrderForAnimation(1))
        dispatch(setAnimationControlType("pause"))
      }
    }

    useEffect(() => {
      const index = Math.floor((animationControlRoute / 100) * (topPagesMapSingleShipmentItemLocationList.length - 1)); // Girilen değere göre liste indeksini hesapla
      // const element = list[index];
      dispatch(setActiveLocationOrderForAnimation(index))
      // setSelectedElement(element);

      return () => {
        dispatch(setAnimationControlType("pause"))

      }
    },[animationControlRoute])


    useEffect(()=> {
      
      if (animationControlSpeed && animationControlType === "animate") {
        const interval = setInterval(() => {
          dispatch(setActiveLocationOrderForAnimation(activeLocationOrderForAnimation >= 1 && activeLocationOrderForAnimation < topPagesMapSingleShipmentItemLocationList.length  ? activeLocationOrderForAnimation+1 : 1))
        }, 1500 / animationControlSpeed);
  
        return () => clearInterval(interval); // Temizleme işlemi
      }
    },[animationControlSpeed, animationControlType, activeLocationOrderForAnimation])


  return (
    <Container>

        <div className="animation-container">
          <div className="animation-item">
            <h4>Gösterim</h4>
            <div className="view-grp">
              <span className="view-name">Rota</span>
              <span className="colon">:</span>
              <InputCheckbox data={animationViewType === "route"} handleClick={() => dispatch(setAnimationViewType("route"))} labelText={"Çizgi"} fontWeight="600"/>
              <InputCheckbox data={animationViewType === "icon"} handleClick={() => dispatch(setAnimationViewType("icon"))} labelText={"İkon"} fontWeight="600"/>
            </div>
          </div>

          {
            animationViewType === "icon" &&
            <>
              <div className="date-filter-container">
                  <div className="date-filter-item">
                      <h4 className="date-filter-item-title">Başlangıç Tarihi:</h4>
                      <FilterDateInput data={filterStartDate} limit={minDate} type={"start"}/>
                  </div>
                  <div className="date-filter-item">
                      <h4 className="date-filter-item-title">Bitiş Tarihi:</h4>
                      <FilterDateInput data={filterEndDate} limit={maxDate} type={"end"}/>
                  </div>
              </div>
              <div className="animation-item">
              <h4>Filtre</h4>
              <div className="filter-container">
                <InputCheckbox data={locationPointPauseFilter} handleClick={() => {dispatch(setLocationPointPauseFilter(!locationPointPauseFilter))}} labelText={"Duraklama noktalarına göre"} fontWeight="600"/>
                <div className="filter-item">
                  <InputCheckbox data={maxSpeedFilter} handleClick={() => dispatch(setMaxSpeedFilter(!maxSpeedFilter))} labelText={"Maksimum hıza göre"} fontWeight="600"/>
                  <InputNumberNew data={maxSpeedValue} setData={(e) => dispatch(setMaxSpeedValue(parseInt(e.target.value)))}inputWidth={"70px"} labelText="" max={4}/>
                </div>
              </div>
              </div>
            </>
          }

        {
          animationViewType === "route" &&
          <>
            <div className="animation-item">
              <h4>Rota Geçmişi</h4>
              <LineRouteSliderInput/>
            </div>
            <div className="animation-item">
              <h4>Animasyon Kontrol</h4>
              <div className="arr-control-container">
                <div className="arr-control-item" onClick={() => handleAnimationClick("back")}>
                  <img src={left} alt="" className="arr-control-item-icon"/>
                </div>
                <div className="arr-control-item" onClick={() => handleAnimationClick(animationControlType === "animate" ? "pause" : "animate")}>
                  <img src={animationControlType === "animate" ? run : pause} alt="" className="arr-control-item-icon"/>
                </div>
                <div className="arr-control-item" onClick={() => handleAnimationClick("forward")}>
                  <img src={right} alt="" className="arr-control-item-icon"/>
                </div>
              </div>
              <div style={{margin: "10px 0"}}>
                <InputCheckbox data={animationFocusType} setData={() => dispatch(setAnimationFocusType(!animationFocusType))} labelText={"Animasyon sırasında konuma odakla"} fontWeight="600"/>
              </div>
            </div>
            <div className="animation-item">
              <h4>Animasyon Hızı (x{parseInt(animationControlSpeed)})</h4>
              <LineSpeedSliderInput/>
            </div>
          </>
          }
        </div>

    </Container>
  )
}

export default TopPagesMapLeftSideAnimationSection